export default __webpack_public_path__ + "static/media/servisorFinal.0a21f09c.svg";